/**
 * Admin Marketing Page Wrapper
 * 
 * Page-level component that wraps the Marketing page content
 * with the standard admin layout (nav, footer).
 */
import React from "react";
import AdminNav from "@/components/AdminNav";
import AdminTopMenuBar from "@/components/AdminTopMenuBar";
import AdminMobileBottomNav from "@/components/AdminMobileBottomNav";
import UniversalFooter from "@/components/UniversalFooter";
import MarketingPage from "@/components/admin/marketing/MarketingPage";

const AdminMarketingPage = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <AdminNav />
      <AdminTopMenuBar />
      
      <main className="mx-auto max-w-7xl px-4 py-8 pb-24 md:pb-8">
        <MarketingPage />
      </main>

      <AdminMobileBottomNav />
      <UniversalFooter />
    </div>
  );
};

export default AdminMarketingPage;
